var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", staticStyle: { height: "calc(15% - 2px)" } },
    [
      _c("div", { staticClass: "navHead flex" }, [
        _c("div", { staticClass: "cube flex" }, [
          _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.zdN))]),
          _c("div", [
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.zd))]),
            _c("span", { staticClass: "unit" }, [
              _vm._v("（" + _vm._s(_vm.unit) + "）"),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "xseBox flex" }, [
          _c("div", { staticClass: "flex olineBox" }, [
            _c("div", { staticClass: "xse" }, [
              _c("div", [
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.xs))]),
                _c("span", { staticClass: "unit" }, [
                  _vm._v("（" + _vm._s(_vm.unit) + "）"),
                ]),
              ]),
              _c("div", { staticClass: "name" }, [
                _c("span", {
                  staticClass: "pointNode",
                  staticStyle: { background: "#FED405" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.xsN))]),
              ]),
            ]),
            _c("div", { staticClass: "xse" }, [
              _c("div", [
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.xx))]),
                _c("span", { staticClass: "unit" }, [
                  _vm._v("（" + _vm._s(_vm.unit) + "）"),
                ]),
              ]),
              _c("div", { staticClass: "name" }, [
                _c("span", {
                  staticClass: "pointNode",
                  staticStyle: { background: "#00B7EF" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.xxN))]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "progess" }, [
            _c("div", {
              staticClass: "progess_line",
              style: { width: _vm.widthLine },
            }),
            _c("div", { staticClass: "rotate rotate2" }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }